<div class="aspect-auto flex min-h-screen max-h-screen justify-center items-center relative overflow-hidden">
    <img [src]="'images/onboarding/onboard_orange.svg' | assetUrl" alt=""
        class="absolute top-[-4rem] left-[-4rem]  z-20">

    <img [src]="'images/onboarding/onboard_blue.svg' | assetUrl" alt=""
        class="absolute top-[-4rem] right-[-4rem] opacity-80">

    <img [src]="'images/onboarding/onboard_orange_bottom.svg' | assetUrl" alt="" class="absolute w-full bottom-0">
    <img [src]="'images/onboarding/onboard_step1_bottom.svg' | assetUrl" alt=""
        class="absolute bottom-0 z-20 w-full lg:max-h-[15rem] 2xl:max-h-[20rem]">
    @if(loading){
    <div class="flex items-center justify-center h-full">
        <div>
            <h1 class="text-3xl">
                {{'Loading your profile setup screen ...' | textCase}}
            </h1>
        </div>
        <div class="ml-4">
            <p-progressSpinner strokeWidth="4" [style]="{width: '1.875rem', height: '1.875rem'}"
                fill="var(--surface-ground)" animationDuration=".5s" />
        </div>
    </div>
    }@else {
    @if (userLimitExceeded) {
    <!-- User Limit Exceeded Message -->
    <div class="flex flex-col items-center justify-center gap-6 text-center max-w-md">
        <div class="flex items-center justify-center w-24 h-24 rounded-full bg-orange-100">
            <i class="pi pi-exclamation-triangle text-orange-500 text-5xl"></i>
        </div>
        <div>
            <h1 class="text-3xl font-bold text-gray-800 mb-3">{{'Organization Limit Reached' | textCase}}</h1>
            <p class="text-lg text-gray-600 mb-2">
                {{'The maximum number of users for this organization has been reached.' | textCase}}
            </p>
            <p class="text-gray-500">
                {{'Please contact your organization administrator to upgrade the plan or manage existing users.' |
                textCase}}
            </p>
        </div>
    </div>
    } @else if (validInvite) {
    <div class="bg-white rounded-base z-50 shadow-lg shadow-arena-orange-200 max-h-[85vh] flex flex-col">
        <div class="sticky top-0 bg-white rounded-t-xl p-4 border-gray-100 z-10">
            <div class="flex flex-col gap-2">
                <span class="text-sm">{{'Step 1 of 1' | textCase}}</span>
                <p-progressbar [value]="100">
                    <ng-template #content let-value>
                    </ng-template>
                </p-progressbar>
            </div>
        </div>
        <div class="flex-1 overflow-y-auto px-4 pb-4 lg:w-[50vw] 2xl:w-[40vw]">
            <div class="flex flex-col gap-2">
                <h2 class="text-2xl font-bold text-black">{{'Setup your profile' | textCase}}</h2>
                <form [formGroup]="profileForm" class="flex flex-col gap-2">
                    <div class="flex flex-row gap-4" (ngSubmit)="onSubmitProfile()">
                        <div class="relative">
                            <img [src]="profileForm.get('profilePicture')?.value" class="h-[5rem] w-[5rem] rounded-full"
                                alt="Profile">
                            @if(profileForm.get('profilePicture')?.value &&
                            profileForm.get('profilePicture')?.value !== this.PROFILE_PICTURES().MALE &&
                            profileForm.get('profilePicture')?.value !== this.PROFILE_PICTURES().FEMALE) {
                            <div
                                class="absolute bottom-0 right-[5%] w-[22px] h-[22px] bg-black/50 rounded-full flex items-center justify-center cursor-pointer">
                                <i class="pi pi-times text-white !text-[10px]" (click)="removePicture()"></i>
                            </div>
                            }
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="text-sm font-bold text-black">{{'Profile Picture' | textCase}}</div>
                            <app-button label="{{'Upload Picture' | textCase}}" icon="pi pi-upload"
                                (clicked)="fileInput.click()" variant="outlined" severity="contrast" />
                            <input #fileInput type="file" accept="image/jpeg,image/jpg,image/png,image/gif"
                                (change)="onFileSelect($event)" style="display: none;" />
                            <p class="text-xs text-gray-500 italic">{{'You can setup your profile picture later in
                                settings' | textCase}}</p>
                        </div>
                    </div>

                    <div class="flex flex-row gap-2 w-full">
                        <div class="form-field flex-1">
                            <label for="firstName">{{'First Name' | textCase}}<span class="text-danger">*</span></label>
                            <input id="firstName" formControlName="firstName"
                                class="input-field w-full border-gray-300 focus:border-orange-500 focus:ring-orange-500 focus:outline-none"
                                placeholder="{{'John' | textCase}}" />

                            @if( profileForm.controls['firstName'].errors &&
                            profileForm.controls['firstName'].touched){
                            <div class="text-danger"><small>{{"*First Name is Required" | textCase}}</small></div>
                            }
                        </div>

                        <div class="form-field flex-1">
                            <label for="lastName">{{'Last Name' | textCase}}<span class="text-danger">*</span></label>
                            <input id="lastName" formControlName="lastName"
                                class="input-field w-full border-gray-300 focus:border-orange-500 focus:ring-orange-500 focus:outline-none"
                                placeholder="{{'Smith' | textCase}}" />
                            @if( profileForm.controls['lastName'].errors &&
                            profileForm.controls['lastName'].touched){
                            <div class="text-danger"><small>{{"*Last Name is Required" | textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex">
                        <div class="form-field">
                            <label for="gender">{{'Gender' | textCase}}<span class="text-danger">*</span>
                                <i class="pi pi-info-circle ml-1 text-gray-500"
                                    pTooltip="{{'This just helps us pick an avatar to start with, gender isn\'t a big deal here' | textCase}}"
                                    tooltipPosition="right" style="font-size: 0.75rem;"></i>
                            </label>
                            <div class="flex gap-3 items-center justify-items-center">
                                <div class="flex items-center">
                                    <p-radioButton name="gender" value="MALE" formControlName="gender" inputId="male"
                                        (ngModelChange)="avatarValidator()" />
                                    <span for="male" class="ml-2 text-sm">
                                        {{'Male' | textCase}}
                                    </span>
                                </div>
                                <div class="flex items-center">
                                    <p-radioButton name="gender" value="FEMALE" formControlName="gender"
                                        (ngModelChange)="avatarValidator()" inputId="female" />
                                    <span for="female" class="ml-2 text-sm">
                                        {{'Female' | textCase}}
                                    </span>
                                </div>
                            </div>
                            @if( profileForm.controls['gender'].errors &&
                            profileForm.controls['gender'].touched){
                            <div class="text-danger"><small>{{"*Gender is Required" | textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex">
                        <div class="form-field flex-1">
                            <label for="email">{{'Email' | textCase}}<span class="text-danger">*</span></label>
                            <input id="email" formControlName="email"
                                class="input-field w-full border-gray-300 focus:border-orange-500 focus:ring-orange-500 focus:outline-none"
                                readonly placeholder="{{'John' | textCase}}" />

                            @if( profileForm.controls['email'].errors &&
                            profileForm.controls['email'].touched){
                            <div class="text-danger"><small>{{"*Email is Required" | textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex">
                        <div class="form-field flex-1">
                            <label for="username">{{'Username' | textCase}}<span class="text-danger">*</span></label>
                            <input id="username" formControlName="username"
                                class="input-field w-full border-gray-300 focus:border-orange-500 focus:ring-orange-500 focus:outline-none"
                                placeholder="{{'John' | textCase}}" />

                            @if( profileForm.controls['username'].errors &&
                            profileForm.controls['username'].touched){
                            <div class="text-danger"><small>{{"*Username is Required" | textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex flex-row gap-2">
                        <div class="form-field flex-1">
                            <label for="password">{{'Password' | textCase}}<span class="text-danger">*</span></label>
                            <p-password id="password" class="border-1" class="w-full" formControlName="password"
                                [toggleMask]="true" appendTo="body" />
                            @if( profileForm.controls['password'].errors &&
                            profileForm.controls['password'].touched){
                            <div class="text-danger"><small>{{"*Password is Required" | textCase}}</small></div>
                            }
                        </div>
                        <div class="form-field flex-1">
                            <label for="confirmPassword">{{'Confirm Password' | textCase}}<span
                                    class="text-danger">*</span></label>
                            <p-password id="confirmPassword" class="border-1 w-full" formControlName="confirmPassword"
                                [toggleMask]="true" [disabled]="!profileForm.controls['password'].value"
                                appendTo="body" />
                            @if(!profileForm.controls['confirmPassword'].valid &&
                            profileForm.controls['confirmPassword'].touched){
                            <div class="text-danger"><small>{{"*Confirm Password is Required" | textCase}}</small>
                            </div>
                            }
                            @if(profileForm.hasError('mismatch') && profileForm.touched){
                            <div class="text-danger">
                                <small>*{{"Passwords Do Not Match." | textCase}}</small>
                            </div>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="sticky bottom-0 bg-white rounded-b-xl p-4  border-gray-100">
            <div class="flex flex-col gap-2">
                <app-button type="submit" variant="filled" severity="primary"
                    [disabled]="!profileForm.valid || submitInProcess" [loading]="submitInProcess"
                    (clicked)="onSubmitProfile()" [fullWidth]="true" [label]="'Finish' | textCase" />
            </div>
        </div>
    </div>
    } @else {
    <div>
        <h1 class="text-4xl">{{'Oops!' | textCase}}</h1>
        <h2 class="text-3xl">{{'Invite has been expired or revoked' | textCase}}</h2>
        <p class="text-gray-400">{{'Please contact the admin for a new invite' | textCase}}</p>
    </div>
    }
    }
</div>